
// Libs einbinden
import Toastify from "../../vendor/toastify-js/src/toastify.js";
import Cookies from "../../vendor/js.cookie.js";

// Einstellungen
var rootPath = '/';

// Vars
var display_mode = Cookies.get('pac_displaymode');
if(display_mode === undefined) display_mode = 'mobile';

// Polyfill für closest
if(!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                              Element.prototype.webkitMatchesSelector;
}
if(!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// Element in Array verschieben
if(!Array.prototype.move) {
    Array.prototype.move = function(old_index, new_index) {
        if ( this.length === 0 ) {
            return this;
        }
        while (old_index < 0) {
            old_index += this.length;
        }
        while (new_index < 0) {
            new_index += this.length;
        }
        if (new_index >= this.length) {
            var k = new_index - this.length;
            while ((k--) + 1) {
                this.push(undefined);
            }
        }
        this.splice(new_index, 0, this.splice(old_index, 1)[0]);
        return this; // for testing purposes
    };
}

// Modul Webapp
var Webapp = {

    spinner: null,

    // Konstruktor
    load: function() {

        var el = document.createElement("div");
        el.classList.add('spinner');
        el.classList.add('inactive');
        el.innerHTML = '<div class="spinner-activity"></div>';
        document.body.insertBefore(el, document.body.firstChild);
        Webapp.spinner = el;

        Webapp.checkDisplayMode();
        window.addEventListener('resize', Webapp.checkDisplayMode);
    },

    // Liefert URL
    getUrl: function(controller, parameter, get_parameter) {

        // Parameter initialisieren
        if(typeof controller === "undefined")       controller = "";
        if(typeof parameter === "undefined")        parameter = "";
        if(typeof parameter === "number")           parameter = parameter.toString();
        if(typeof get_parameter === "undefined")    get_parameter = [];

        // Parameter prüfen
        if(typeof controller !== "string")          return false;
        if(typeof parameter !== "string")           return false;
        if(typeof get_parameter !== "object")       return false;

        // Parameter bereinigen
        controller  = controller.trim();
        if(typeof parameter === "string") parameter = parameter.trim();

        // URL zusammenstellen
        var url = window.location.protocol + "//" + window.location.hostname + rootPath;

        if(controller.length > 0) {
            url += controller+'/';
            if(parameter.length > 0){
                url += parameter+'/';
            }
        }
        url = url.substring(0, url.length - 1);

        if(typeof get_parameter === "object") {
            url += '?';
            Object.keys(get_parameter).forEach(function(key, index) {

                var value = this[key].toString();
                if(key.length > 0 && value.length > 0) {
                    url += key.trim() + '=' + value.trim() + '&';
                }

            }, get_parameter);
            url = url.substring(0, url.length - 1);
        }

        // liefern
        return url;
    },

    // Weiterleitung zu Backoffice-Seite
    goto: function(controller, parameter, get_parameter) {
        var url = Webapp.getUrl(controller, parameter, get_parameter);
        if(url === false) {
            console.log('Konnte URL für Seitenweiterleitung nicht erstellen!');
            return;
        }
        Webapp.gotoUrl(url);
    },

    // Weiterleitung zu URL
    gotoUrl: function(url) {
        window.location = url;
    },

    // Zeigt Meldung an
    notification: function(msg, cssclass) {
        var duration = 3000;
        if(cssclass == 'error') {
            duration = 10000;
        }
        Toastify({
          text: msg,
          duration: duration,
          gravity: "bottom",
          stopOnFocus: true,
          className: cssclass
        }).showToast();
    },

    // Ladeanzeige einblenden
    showSpinner: function() {
        if(Webapp.spinner) {
            Webapp.spinner.classList.remove('inactive');
        }
    },

    // Ladeanzeige ausblenden
    hideSpinner: function() {
        if(Webapp.spinner) {
            Webapp.spinner.classList.add('inactive');
        }
    },

    // Führt XHR-Request aus
    xhrRequest: function(url, method, data, beforeFunction, afterFunction, successFunction) {

        var request = new XMLHttpRequest();
        request.open(method, url, true);
        request.setRequestHeader('x-requested-with', 'xmlhttprequest');

        request.onload = function() {
            Webapp.hideSpinner();
            afterFunction();
            if (this.status >= 200 && this.status < 400) {

                var respData = JSON.parse(this.response);

                if(typeof(respData.success) !== 'undefined' && respData.success == true) {
                    successFunction(respData);
                }
                else {
                    var msg = 'Unbekannter Fehler!';
                    if(typeof(respData.error_msg) !== 'undefined' && respData.error_msg.length > 0) {
                        msg = respData.error_msg;
                    }
                    Webapp.notification(msg, 'error');
                }

            } else {
                Webapp.notification('Server-Fehler: '+this.status, 'error');
            }
        };

        request.onerror = function() {
            Webapp.notification('Datenübertragung fehlgeschlagen! '+request.responseText, 'error');
        };

        Webapp.showSpinner();
        beforeFunction();

        request.send(data);
    },

    // Führt Formular-Übertragung aus
    formSubmit: function(url, formId, successMsg, successFunction, successWaiting) {

        var form = document.getElementById(formId);
        if(form === null) {
            Webapp.notification('Formular unbekannt!', 'error');
            return;
        }
        var submitBtn = form.querySelectorAll("button[type=submit]")[0];

        // on submit
        form.addEventListener("submit", function(event){
            event.preventDefault();
            var data = new FormData(form);

            Webapp.xhrRequest(url, 'POST', data, function(){
                submitBtn.setAttribute( "disabled", true );
            }, function(){
                submitBtn.removeAttribute( "disabled" );
            }, function(resp){
                submitBtn.removeAttribute( "disabled" );
                Webapp.notification(successMsg, 'success');

                // wenn in Modal > schliessen
                var modal = form.closest('.uk-modal.uk-open');
                if(typeof modal !== 'undefined') {
                    UIkit.modal(modal).hide();
                }

                successFunction(resp);
            });
        });
    },

    // Modal-Dialog: Löschvorgang
    modalDeletion: function(header, text, options) {

        options = extend({bgClose: true, escClose: true, labels: { cancel: "Abbrechen", ok: "Löschen" }, stack: true }, options);

        return new Promise(
            function (resolve, reject) {

                var html = "<div class=\"uk-modal-header\"><span uk-icon=\"icon: trash; ratio: 3\" class=\"uk-float-left uk-margin-small-right\"></span><h2 class=\"uk-modal-title uk-margin-remove\">"+header+"</h2></div>";
                if(typeof text === "string" && text.length > 0) {
                    html += "<div class=\"uk-modal-body\">" + text + "</div>";
                }
                html += "<div class=\"uk-modal-footer uk-text-right\"><button class=\"uk-button uk-button-default uk-modal-close\">" + (options.labels.cancel) + "</button><button class=\"submit uk-button uk-button-danger uk-modal-close uk-margin-small-left\" autofocus>" + (options.labels.ok) + "</button></div>";

                var dialog = UIkit.modal.dialog(html, options);

                var btns = dialog.$el.querySelectorAll('.uk-modal-footer button');
                Array.prototype.forEach.call(btns, function(el, i){
                    el.addEventListener('click', function(event){
                        if(this.classList.contains('submit')) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    });
                });

                return dialog;
            }
        );
    },

    // Dialog zu Löschvorgang
    deletionDialog: function(urlXhrDeletion, parameter, successFunction) {

        Webapp.xhrRequest(urlXhrDeletion, 'POST', getFormData(parameter), function(){}, function(){}, function(data){

            var questionHeader = "Eintrag löschen:";
            if(typeof data.question_header === "string" && data.question_header.length > 0)
                questionHeader = data.question_header;

            var questionText = "Möchten Sie den gewählten Eintrag wirklich löschen!";
            if(typeof data.question_text === "string" && data.question_text.length > 0)
                questionText = data.question_text;

            Webapp.modalDeletion(questionHeader, questionText).then(function() {

                parameter.confirmed = 1;

                Webapp.xhrRequest(urlXhrDeletion, 'POST', getFormData(parameter), function(){}, function(){}, function(data){

                    var successText = "Eintrag wurde gelöscht!";
                    if(typeof data.success_text === "string" && data.success_text.length > 0)
                        successText = data.success_text;
                    Webapp.notification(successText, 'success');

                    if(typeof successFunction === "function") {
                        successFunction();
                    }
                });

            }, function(){});
        });
    },

    // Prüft den Display-Mode
    checkDisplayMode: function() {

        var width = document.body.clientWidth;

        var mode = 'mobile';
        if(width >= 768)
            mode = 'desktop';

        if(display_mode != mode) {
            Cookies.set('pac_displaymode', mode);
        }
    },

};

// Konstruktor ausführen
window.addEventListener('load', Webapp.load);

// Extend Function
var extend = function(out) {
  out = out || {};

  for (var i = 1; i < arguments.length; i++) {
    if (!arguments[i])
      continue;

    for (var key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key))
        out[key] = arguments[i][key];
    }
  }

  return out;
};

// JSON to FormData
var getFormData = function(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
}

// -------------------

// Login
if(document.querySelectorAll('body.login').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('login-submit'), 'form-login', 'Sie sind eingeloggt!', function(response){
        setTimeout(function(){ Webapp.goto(''); }, 1000);
    });
}

// Mitarbeiter-Eintrag
if(document.querySelectorAll('body.mitarbeitereintrag').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('mitarbeitereintrag-submit'), 'form-mitarbeitereintrag', 'Gespeichert!', function(response){
        setTimeout(function(){ Webapp.goto(); }, 2000);
    });
}

// Mitarbeiter anlegen
if(document.querySelectorAll('body.mitarbeiter-add').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('mitarbeiter-add-submit'), 'form-mitarbeiter-add', 'Mitarbeiter angelegt!', function(response){
        setTimeout(function(){ Webapp.goto('mitarbeiter#employee-'+response.new_employee_id); }, 2000);
    });
}

// Mitarbeiter bearbeiten
if(document.querySelectorAll('body.mitarbeiter-edit').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('mitarbeiter-edit-submit'), 'form-mitarbeiter-edit', 'Angaben gespeichert!', function(response){
        setTimeout(function(){ Webapp.goto('mitarbeiter#employee-'+response.edit_employee_id); }, 2000);
    });

    // Mitarbeiter löschen
    var btnDelete = document.getElementById("btn-mitarbeiter-delete");
    if(typeof btnDelete === 'object') {
        btnDelete.addEventListener('click', function(event){

            Webapp.deletionDialog(
                Webapp.getUrl('mitarbeiter-delete'),
                { id: document.querySelectorAll('form input[name=id]')[0].value },
                function(){
                    setTimeout(function(){
                        Webapp.goto('mitarbeiter');
                    }, 2000);
                }
            );

        });
    }
}

// Standort anlegen
if(document.querySelectorAll('body.standort-add').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('standort-add-submit'), 'form-standort-add', 'Standort angelegt!', function(response){
        setTimeout(function(){ Webapp.goto('standortverwaltung#location-'+response.new_location_id); }, 2000);
    });
}

// Standort bearbeiten
if(document.querySelectorAll('body.standort-edit').length === 1) {

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('standort-edit-submit'), 'form-standort-edit', 'Angaben gespeichert!', function(response){
        setTimeout(function(){ Webapp.goto('standortverwaltung#location-'+response.edit_location_id); }, 2000);
    });

    // Standort löschen
    var btnDelete = document.getElementById("btn-standort-delete");
    if(typeof btnDelete === 'object') {
        btnDelete.addEventListener('click', function(event){

            Webapp.deletionDialog(
                Webapp.getUrl('standort-delete'),
                { id: document.querySelectorAll('form input[name=id]')[0].value },
                function(){
                    Webapp.goto('standortverwaltung');
                }
            );

        });
    }
}

// Modul: Dienstplan FahrerInnen
var EntriestableFahrer = {

    optionsAdd: [],
    entries: [],
    select: null,
    radios: null,
    formAdd: null,
    table: null,
    alert: null,
    input: null,

    init: function() {

        // Elemente
        this.radios = document.querySelectorAll('form input[name=region_id]');
        this.select = document.querySelectorAll('#modal-employee-add select')[0];
        this.formAdd = document.getElementById('form-employee-add');
        this.table = document.querySelectorAll('.entriestable')[0];
        this.alert = this.table.querySelectorAll('.uk-alert')[0];
        this.input = this.table.querySelectorAll('input[type=hidden]')[0];

        // Liste der Mitarbeiter-Options erstellen
        var options = this.select.querySelectorAll('option');
        for (var i=0; i < options.length; i++) {
            this.optionsAdd.push({
                id: parseInt(options[i].getAttribute('value')),
                name: options[i].textContent,
                region_id: parseInt(options[i].getAttribute('data-region-id'))
            });
        }

        // Wechsel der Region
        Array.prototype.forEach.call(this.radios, function(el, i){
            el.addEventListener('change', function() {
                EntriestableFahrer.reset();
            });
        });

        // Button hinzufügen
        this.formAdd.addEventListener("submit", function(event){
            event.preventDefault();
            EntriestableFahrer.add();
        });

        // Auswahl einrichten
        this.reset();

        // Liste laden
        if(this.input.value != "") {
            this.entries = [];
            var ids = this.input.value.split(",");
            var region_selected = 0;
            for (var i=0; i < this.radios.length; i++) {
                if (this.radios[i].checked==true) {
                    region_selected = parseInt(this.radios[i].value);
                    break;
                }
            }
            for (var i=0; i < ids.length; i++) {
                var data = {};
                for (var n=0; n < this.optionsAdd.length; n++) {
                    if(this.optionsAdd[n].id === parseInt(ids[i]) && region_selected === this.optionsAdd[n].region_id) {
                        data = this.optionsAdd[n];
                        break;
                    }
                }
                if(data.id !== undefined) {
                    this.entries.push(data);
                }
            }
            this.renderTable();
        }
    },

    reset: function() {

        // aktuelle Region-Auswahl ermitteln
        var region_id = 0;
        for (var i=0; i < this.radios.length; i++) {
            if (this.radios[i].checked==true) {
                region_id = this.radios[i].value;
                break;
            }
        }

        // Tabelle leeren
        this.entries = [];
        this.renderTable();

        // Add-Select aktualisieren
        var html = '<option value="0"></option>';
        for (var i=0; i < this.optionsAdd.length; i++) {
            if(this.optionsAdd[i].region_id == region_id) {
                html += '<option value="'+this.optionsAdd[i].id+'">'+this.optionsAdd[i].name+'</option>';
            }
        }
        this.select.innerHTML = html;
    },

    renderTable: function() {

        var tbody = this.table.querySelectorAll('tbody')[0];

        // keine Einträge
        if(this.entries.length === 0) {

            // Tabelle leeren
            tbody.innerHTML = '';

            // Alert anzeigen
            this.alert.style.display = '';

            return;
        }

        // Alert ausblenden
        this.alert.style.display = 'none';

        // HTMl-Code erstellen
        var html = '';
        for (var i=0; i < this.entries.length; i++) {

            var d = this.entries[i];

            html += '<tr data-id="'+d.id+'">';
            html += '    <td class="uk-flex uk-flex-middle">';
            html += '        '+d.name;
            html += '    </td>';
            html += '    <td class="uk-text-right">';
            html += '        <div class="uk-inline">';
            html += '            <button class="uk-button uk-button-default uk-button-small" type="button"><svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#more-vertical"/></svg></button>';
            html += '            <div uk-dropdown="mode:click;pos:top-right;offset:3;">';
            html += '                <ul class="uk-nav uk-dropdown-nav">';
            html += '                    <li class="action-up">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#arrow-up"/></svg>';
            html += '                            Nach oben';
            html += '                        </a>';
            html += '                    </li>';
            html += '                    <li class="action-down">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#arrow-down"/></svg>';
            html += '                            Nach unten';
            html += '                        </a>';
            html += '                    </li>';
            html += '                    <li class="action-delete">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#trash"/></svg>';
            html += '                            Entfernen';
            html += '                        </a>';
            html += '                    </li>';
            html += '                </ul>';
            html += '            </div>';
            html += '        </div>';
            html += '    </td>';
            html += '</tr>';
        }

        // Tabelle anzeigen
        tbody.innerHTML = html;

        // Events registrieren
        var btnsDelete = tbody.querySelectorAll('.action-delete > a');
        for (var i=0; i < btnsDelete.length; i++) {
            btnsDelete[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var id = parseInt(tr.getAttribute('data-id'));
                EntriestableFahrer.delete(id);
            });
        }
        var btnsUp = tbody.querySelectorAll('.action-up > a');
        for (var i=0; i < btnsUp.length; i++) {
            btnsUp[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var id = parseInt(tr.getAttribute('data-id'));
                EntriestableFahrer.up(id);
            });
        }
        var btnsDown = tbody.querySelectorAll('.action-down > a');
        for (var i=0; i < btnsDown.length; i++) {
            btnsDown[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var id = parseInt(tr.getAttribute('data-id'));
                EntriestableFahrer.down(id);
            });
        }

        // Wert setzen
        this.updateInputValue();
    },

    add: function() {

        var id = parseInt(this.select.value);

        if(id === 0) {
            Webapp.notification('Mitarbeiter auswählen!', 'error');
        }

        else {

            var data = {};
            for (var i=0; i < this.optionsAdd.length; i++) {
                if(this.optionsAdd[i].id === id) {
                    data = this.optionsAdd[i];
                    break;
                }
            }
            if(data.id === undefined) {
                return;
            }

            var found = false;
            for (var i=0; i < this.entries.length; i++) {
                if(this.entries[i].id === id) {
                    found = true;
                    break;
                }
            }
            if(!found) {
                this.entries.push(data);
            }

            this.renderTable();

            // Modal schliessen
            UIkit.modal('#modal-employee-add').hide();
        }
    },

    delete: function(id) {
        var newList = [];
        for (var i=0; i < this.entries.length; i++) {
            if(this.entries[i].id !== parseInt(id)) {
                newList.push(this.entries[i]);
            }
        }
        this.entries = newList;
        this.renderTable();
    },

    up: function(id) {
        var index = 0;
        for (var i=0; i < this.entries.length; i++) {
            if(this.entries[i].id === parseInt(id)) {
                index = i;
                break;
            }
        }
        this.entries.move(index, index-1);
        this.renderTable();
    },

    down: function(id) {
        var index = 0;
        for (var i=0; i < this.entries.length; i++) {
            if(this.entries[i].id === parseInt(id)) {
                index = i;
                break;
            }
        }
        this.entries.move(index, index+1);
        this.renderTable();
    },

    updateInputValue: function() {
        var value = [];
        for (var i=0; i < this.entries.length; i++) {
            value.push(this.entries[i].id);
        }
        this.input.value = value.join();
    }
};

// Dienstplan anlegen
if(document.querySelectorAll('body.dienstplan-add').length === 1) {

    // FahrerInnen
    EntriestableFahrer.init();

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('dienstplan-add-submit'), 'form-dienstplan-add', 'Dienstplan angelegt!', function(response){
        setTimeout(function(){ Webapp.goto('dienstplanverwaltung#roster-'+response.new_roster_id); }, 2000);
    });

}

// Dienstplan bearbeiten
if(document.querySelectorAll('body.dienstplan-edit').length === 1) {

    // FahrerInnen
    EntriestableFahrer.init();

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('dienstplan-edit-submit'), 'form-dienstplan-edit', 'Angaben gespeichert!', function(response){
        setTimeout(function(){ Webapp.goto('dienstplanverwaltung#roster-'+response.edit_roster_id); }, 2000);
    });

    // Dienstplan löschen
    var btnDelete = document.getElementById("btn-dienstplan-delete");
    if(typeof btnDelete === 'object') {
        btnDelete.addEventListener('click', function(event){

            Webapp.deletionDialog(
                Webapp.getUrl('dienstplan-delete'),
                { id: document.querySelectorAll('form input[name=id]')[0].value },
                function(){
                    setTimeout(function(){
                        Webapp.goto('dienstplanverwaltung');
                    }, 2000);
                }
            );

        });
    }
}

// Routenverwaltung
if(document.querySelectorAll('body.routenverwaltung').length === 1) {

    // Änderung der Dienstplanauswahl
    var select = document.getElementById("input-roster");
    select.addEventListener('change', function(event){
        document.getElementById("form-rosterselection").submit();
    });

}

// Modul: Routen Standorte
var EntriestableLocations = {

    entries: [],
    select: null,
    formAdd: null,
    table: null,
    alert: null,
    input: null,

    init: function() {

        // Elemente
        this.select = document.querySelectorAll('#modal-location-add select')[0];
        this.formAdd = document.getElementById('form-location');
        this.table = document.querySelectorAll('.entriestable')[0];
        this.alert = this.table.querySelectorAll('.uk-alert')[0];
        this.input = this.table.querySelectorAll('input[type=hidden]')[0];

        // Button hinzufügen
        this.formAdd.addEventListener("submit", function(event){
            event.preventDefault();
            EntriestableLocations.add();
        });

        // Auswahl einrichten
        this.reset();

        // Liste laden
        if(this.input.value != "") {
            this.entries = [];
            var ids = this.input.value.split(",");
            var options = this.select.querySelectorAll('option');
            for (var i=0; i < ids.length; i++) {
                var data = {};
                for (var n=0; n < options.length; n++) {
                    if(parseInt(options[n].getAttribute('value')) === parseInt(ids[i])) {
                        data = {
                            id: options[n].getAttribute('value'),
                            name: options[n].textContent
                        };
                        break;
                    }
                }
                if(data.id !== undefined) {
                    this.entries.push(data);
                }
            }
            this.renderTable();
        }
    },

    reset: function() {

        // Tabelle leeren
        this.entries = [];
        this.renderTable();
    },

    renderTable: function() {

        var tbody = this.table.querySelectorAll('tbody')[0];

        // keine Einträge
        if(this.entries.length === 0) {

            // Tabelle leeren
            tbody.innerHTML = '';

            // Alert anzeigen
            this.alert.style.display = '';

            return;
        }

        // Alert ausblenden
        this.alert.style.display = 'none';

        // HTMl-Code erstellen
        var html = '';
        for (var i=0; i < this.entries.length; i++) {

            var d = this.entries[i];

            html += '<tr data-index="'+i+'">';
            html += '    <td class="uk-flex uk-flex-middle">';
            html += '        '+d.name;
            html += '    </td>';
            html += '    <td class="uk-text-right">';
            html += '        <div class="uk-inline">';
            html += '            <button class="uk-button uk-button-default uk-button-small" type="button"><svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#more-vertical"/></svg></button>';
            html += '            <div uk-dropdown="mode:click;pos:top-right;offset:3;">';
            html += '                <ul class="uk-nav uk-dropdown-nav">';
            html += '                    <li class="action-up">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#arrow-up"/></svg>';
            html += '                            Nach oben';
            html += '                        </a>';
            html += '                    </li>';
            html += '                    <li class="action-down">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#arrow-down"/></svg>';
            html += '                            Nach unten';
            html += '                        </a>';
            html += '                    </li>';
            html += '                    <li class="action-delete">';
            html += '                        <a>';
            html += '                            <svg class="feather"><use xlink:href="'+rootPath+'design/vendor/feather-sprite.svg#trash"/></svg>';
            html += '                            Entfernen';
            html += '                        </a>';
            html += '                    </li>';
            html += '                </ul>';
            html += '            </div>';
            html += '        </div>';
            html += '    </td>';
            html += '</tr>';
        }

        // Tabelle anzeigen
        tbody.innerHTML = html;

        // Events registrieren
        var btnsDelete = tbody.querySelectorAll('.action-delete > a');
        for (var i=0; i < btnsDelete.length; i++) {
            btnsDelete[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var index = parseInt(tr.getAttribute('data-index'));
                EntriestableLocations.delete(index);
            });
        }
        var btnsUp = tbody.querySelectorAll('.action-up > a');
        for (var i=0; i < btnsUp.length; i++) {
            btnsUp[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var index = parseInt(tr.getAttribute('data-index'));
                EntriestableLocations.up(index);
            });
        }
        var btnsDown = tbody.querySelectorAll('.action-down > a');
        for (var i=0; i < btnsDown.length; i++) {
            btnsDown[i].addEventListener('click', function(event){
                var tr = event.target.closest('tr');
                var index = parseInt(tr.getAttribute('data-index'));
                EntriestableLocations.down(index);
            });
        }

        // Wert setzen
        this.updateInputValue();
    },

    add: function() {

        var id = parseInt(this.select.value);

        if(id === 0) {
            Webapp.notification('Standort auswählen!', 'error');
        }

        else {

            var data = {};
            var options = this.select.querySelectorAll('option');

            for (var i=0; i < options.length; i++) {
                if(parseInt(options[i].getAttribute('value')) === id) {
                    data = {
                        id: options[i].getAttribute('value'),
                        name: options[i].textContent
                    };
                    break;
                }
            }
            if(data.id === undefined) {
                return;
            }

            this.entries.push(data);

            this.renderTable();

            // Modal schliessen
            UIkit.modal('#modal-location-add').hide();
        }
    },

    delete: function(index) {
        this.entries.splice(index, 1);
        this.renderTable();
    },

    up: function(index) {
        this.entries.move(index, index-1);
        this.renderTable();
    },

    down: function(index) {
        this.entries.move(index, index+1);
        this.renderTable();
    },

    updateInputValue: function() {
        var value = [];
        for (var i=0; i < this.entries.length; i++) {
            value.push(this.entries[i].id);
        }
        this.input.value = value.join();
    }
};

// Route anlegen
if(document.querySelectorAll('body.route-add').length === 1) {

    // Standorte
    EntriestableLocations.init();

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('route-add-submit'), 'form-route', 'Route angelegt!', function(response){
        setTimeout(function(){ Webapp.goto('routenverwaltung#route-'+response.new_route_id); }, 2000);
    });

}

// Route bearbeiten
if(document.querySelectorAll('body.route-edit').length === 1) {

    // Standorte
    EntriestableLocations.init();

    // Form senden
    Webapp.formSubmit(Webapp.getUrl('route-edit-submit'), 'form-route', 'Angaben gespeichert!', function(response){
        setTimeout(function(){ Webapp.goto('routenverwaltung#route-'+response.edit_route_id); }, 2000);
    });

    // Route löschen
    var btnDelete = document.getElementById("btn-route-delete");
    if(typeof btnDelete === 'object') {
        btnDelete.addEventListener('click', function(event){

            Webapp.deletionDialog(
                Webapp.getUrl('route-delete'),
                { id: document.querySelectorAll('form input[name=id]')[0].value },
                function(){
                    setTimeout(function(){
                        Webapp.goto('routenverwaltung');
                    }, 2000);
                }
            );

        });
    }
}

// Modul: Dienstplan
var Dienstplan = {

    modalAdd: null,
    modalEdit: null,
    modalView: null,
    modalNote: null,
    timerUpdate: null,
    timeLastLoading: null,

    init: function() {

        // Elemente
        Dienstplan.modalAdd = document.getElementById("modal-entry-add");

        // Wechsel von Dienstplan
        var selectRoster = document.getElementById("input-roster");
        if(typeof selectRoster === 'object') {
            selectRoster.addEventListener('change', function(event){
                Webapp.goto('dienstplan', '', { roster_id: selectRoster.value });
            });
        }

        // Klick auf Eintrag hinzufügen
        var btns = document.querySelectorAll('.tablecontainer button.add');
        for (var i=0; i < btns.length; i++) {
            btns[i].addEventListener('click', function(event){

                // Inputs
                var inputEmployee   = Dienstplan.modalAdd.querySelectorAll('input[name=employee_id]')[0];
                var inputNote       = Dienstplan.modalAdd.querySelectorAll('input[name=note]')[0];

                if(display_mode == 'desktop') {
                    var inputWeekday    = Dienstplan.modalAdd.querySelectorAll('input[name=weekday]')[0];
                }
                else if(display_mode == 'mobile') {
                    var inputDay    = Dienstplan.modalAdd.querySelectorAll('input[name=day]')[0];
                }

                // Angaben vorbelegen
                var tr = event.target.closest('tr');
                inputEmployee.value = parseInt(tr.getAttribute('data-employee-id'));

                if(display_mode == 'desktop') {
                    var td = event.target.closest('td');
                    inputWeekday.value = parseInt(td.getAttribute('data-weekday'));
                }
                else if(display_mode == 'mobile') {
                    inputDay.value = document.getElementById("input-day").value;
                }

                inputNote.value = '';

                // Modal anzeigen
                UIkit.modal(Dienstplan.modalAdd).show();
            });
        }

        // Form zum Hinzufügen senden
        Webapp.formSubmit(Webapp.getUrl('dienstplan-addentry-submit'), 'form-add', 'Eintrag hinzugefügt!', function(response){
            Dienstplan.loadEntries();
        });


        if(display_mode == 'desktop') {

            // Elemente
            Dienstplan.modalEdit = document.getElementById("modal-entry-edit");

            // Wechsel der Woche
            var selectWeek = document.getElementById("input-week");
            if(typeof selectWeek === 'object') {
                selectWeek.addEventListener('change', function(event){
                    var get = [];
                    get['week'] = selectWeek.value;
                    Webapp.goto('dienstplan', '', { week: selectWeek.value });
                });
            }

            // Form bei Bearbeitung senden
            Webapp.formSubmit(Webapp.getUrl('dienstplan-editentry-submit'), 'form-edit', 'Eintrag gespeichert!', function(response){
                Dienstplan.loadEntries();
            });

            // Eintrag löschen
            var btnDelete = document.getElementById("btn-entry-delete");
            if(typeof btnDelete === 'object') {
                btnDelete.addEventListener('click', function(event){
                    var id = document.querySelectorAll('#modal-entry-edit input[name=id]')[0].value;
                    Webapp.deletionDialog(
                        Webapp.getUrl('dienstplan-deleteentry'),
                        { id: id },
                        function(){
                            var e = document.querySelectorAll('.tablecontainer .entries > .dienstplan-entry[data-id="'+id+'"]')[0];
                            e.parentNode.removeChild(e);
                            UIkit.modal(Dienstplan.modalEdit).hide();
                        }
                    );
                });
            }

            // Einträge verschieben
            var sortableContainer = document.querySelectorAll('.tablecontainer .entries');
            for (var i=0; i < sortableContainer.length; i++) {

                UIkit.sortable(sortableContainer[i], { group: 'rosterentries' });

                UIkit.util.on(sortableContainer[i], 'moved', function (event) {
                    Dienstplan.movedEntry(event);
                });
                UIkit.util.on(sortableContainer[i], 'added', function (event) {
                    Dienstplan.movedEntry(event);
                });
            }

            // Klick auf: Alle Einträge löschen
            var btns = document.querySelectorAll('.btn-delete-allentries');
            for (var i=0; i < btns.length; i++) {
                btns[i].addEventListener('click', function(event){
                    Dienstplan.deleteAllEntries();
                });
            }

            // Klick auf: Standardeinträge einfügen
            var btns = document.querySelectorAll('.btn-insert-defaultentries');
            for (var i=0; i < btns.length; i++) {
                btns[i].addEventListener('click', function(event){
                    Dienstplan.insertDefaultentries();
                });
            }
        }

        else if(display_mode == 'mobile') {

            // Elemente
            var selectDay = document.getElementById("input-day");
            Dienstplan.modalView = document.getElementById("modal-entry-view");
            Dienstplan.modalNote = document.getElementById("modal-edit-note");

            // Tag vor- und zurück
            var btnDayBack = document.querySelectorAll(".topbar button.day-back")[0];
            var btnDayNext = document.querySelectorAll(".topbar button.day-next")[0];
            btnDayBack.addEventListener('click', function(event){

                var optionSelected = selectDay.options[selectDay.selectedIndex];
                var optionBack = optionSelected.previousElementSibling;

                if(optionBack) {
                    selectDay.value = optionBack.value;
                    selectDay.nextElementSibling.textContent = optionBack.textContent;
                    Dienstplan.loadEntries();
                }
            });
            btnDayNext.addEventListener('click', function(event){

                var optionSelected = selectDay.options[selectDay.selectedIndex];
                var optionNext = optionSelected.nextElementSibling;

                if(optionNext) {
                    selectDay.value = optionNext.value;
                    selectDay.nextElementSibling.textContent = optionNext.textContent;
                    Dienstplan.loadEntries();
                }
            });

            // Tageswechsel
            if(selectDay) {
                selectDay.addEventListener('change', function(event){
                    Dienstplan.loadEntries();
                });
            }

            // Aktion: Notiz bearbeiten
            var btnEditNote = document.querySelectorAll("#modal-entry-view .actions button.edit-note")[0];
            btnEditNote.addEventListener('click', function(event){
                var inputId = document.querySelectorAll("#modal-entry-view input[name=id]")[0];
                var id = inputId.value;
                Dienstplan.editNote(id);
            });

            // Aktion: Nach oben
            var btnMoveUp = document.querySelectorAll("#modal-entry-view .actions button.move-up")[0];
            btnMoveUp.addEventListener('click', function(event){

                var inputId = document.querySelectorAll("#modal-entry-view input[name=id]")[0];
                var id = parseInt(inputId.value);

                var entry = document.querySelectorAll(".tablecontainer .dienstplan-entry[data-id='"+id+"']")[0];
                var beforeEntry = entry.previousElementSibling;

                if(beforeEntry !== null) {
                    var beforeId = parseInt(beforeEntry.getAttribute('data-id'));

                    // Senden
                    Webapp.xhrRequest(
                        Webapp.getUrl('dienstplan-move-entry'),
                        'POST',
                        getFormData({
                            id: id,
                            next_id: beforeId
                        }),
                        function(){},
                        function(){},
                        function(r){
                            UIkit.modal(Dienstplan.modalView).hide();
                            Webapp.notification('Eintrag verschoben!', 'success');
                            Dienstplan.loadEntries();
                        }
                    );
                }
            });

            // Aktion: Nach unten
            var btnMoveDown = document.querySelectorAll("#modal-entry-view .actions button.move-down")[0];
            btnMoveDown.addEventListener('click', function(event){

                var inputId = document.querySelectorAll("#modal-entry-view input[name=id]")[0];
                var id = inputId.value;

                var entry = document.querySelectorAll(".tablecontainer .dienstplan-entry[data-id='"+id+"']")[0];
                var nextEntry = entry.nextElementSibling;

                if(nextEntry !== null) {
                    var nextId = parseInt(nextEntry.getAttribute('data-id'));

                    // Senden
                    Webapp.xhrRequest(
                        Webapp.getUrl('dienstplan-move-entry'),
                        'POST',
                        getFormData({
                            id: id,
                            before_id: nextId
                        }),
                        function(){},
                        function(){},
                        function(r){
                            UIkit.modal(Dienstplan.modalView).hide();
                            Webapp.notification('Eintrag verschoben!', 'success');
                            Dienstplan.loadEntries();
                        }
                    );
                }
            });

            // Aktion: Eintrag löschen
            var btnDel = document.querySelectorAll("#modal-entry-view .actions button.del")[0];
            btnDel.addEventListener('click', function(event){

                var inputId = document.querySelectorAll("#modal-entry-view input[name=id]")[0];
                var id = inputId.value;

                Webapp.deletionDialog(
                    Webapp.getUrl('dienstplan-deleteentry'),
                    { id: id },
                    function(){
                        var e = document.querySelectorAll('.tablecontainer .entries > .dienstplan-entry[data-id="'+id+'"]')[0];
                        e.parentNode.removeChild(e);
                        UIkit.modal(Dienstplan.modalView).hide();
                    }
                );
            });

            // Form bei Notiz-Bearbeitung senden
            Webapp.formSubmit(Webapp.getUrl('dienstplan-editentry-submit'), 'form-edit-note', 'Notiz gespeichert!', function(response){

                // Notiz in Eintragsanzeige übernehmen
                var input = document.querySelectorAll("#modal-edit-note input[name=note]")[0];
                var note = document.querySelectorAll("#modal-entry-view p.note")[0];
                note.textContent = input.value;

                // Einträge im Dienstplan neu laden
                Dienstplan.loadEntries();
            });
        }

        // Einträge laden
        Dienstplan.loadEntries();
    },

    loadEntries: function() {

        // Vor- und Zurück-Buttons de-aktivieren
        if(display_mode == 'mobile') {
            var selectDay = document.getElementById("input-day");
            var btnDayBack = document.querySelectorAll(".topbar button.day-back")[0];
            var btnDayNext = document.querySelectorAll(".topbar button.day-next")[0];
            var optionSelected = selectDay.options[selectDay.selectedIndex];
            var optionBack = optionSelected.previousElementSibling;
            var optionNext = optionSelected.nextElementSibling;
            if(optionBack) {
                btnDayBack.disabled = false;
            }
            else {
                btnDayBack.disabled = true;
            }
            if(optionNext) {
                btnDayNext.disabled = false;
            }
            else {
                btnDayNext.disabled = true;
            }
        }

        // Parameter
        var parameter = {};
        if(display_mode == 'desktop') {
            parameter = {
                roster_id: document.getElementById("input-roster").value,
                week: document.getElementById("input-week").value
            };
        }
        else if(display_mode == 'mobile') {
            parameter = {
                roster_id: document.getElementById("input-roster").value,
                day: document.getElementById("input-day").value
            };
        }

        // Einträge abrufen
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-load-entries'),
            'POST',
            getFormData(parameter),
            function(){},
            function(){},
            function(r){

                Dienstplan.timeLastLoading = r.time;

                // Einträge aufräumen
                var olds = document.querySelectorAll(".tablecontainer .entries");
                for(var n=0;n<olds.length;++n) {
                    olds[n].innerHTML = '';
                }

                // Einträge einfügen
                if(display_mode == 'desktop') {

                    // Wochentage
                    Object.keys(r.entries).forEach(function(key, index) {
                        var weekday = key;

                        // FahrerInnen
                        Object.keys(this[key]).forEach(function(key, index) {
                            var employess_id = key;

                            // Einträge
                            var entries = this[key];
                            var html = '';

                            var entriesDiv = document.querySelectorAll(".tablecontainer tr[data-employee-id='"+employess_id+"'] > td[data-weekday='"+weekday+"'] > .entries")[0];
                            if(entriesDiv !== undefined) {

                                // Markup der Einträge erstellen
                                entries.forEach(function(entry, i){

                                    html += '<div data-id="'+entry.id+'" class="dienstplan-entry uk-light" style="background-color:#'+entry.route_color+';">';
                                    html += '    <span class="title">'+entry.route_name+'</span>';
                                    if(typeof entry.note !== 'undefined' && entry.note.length > 0) {
                                        html += '    '+entry.note;
                                    }
                                    html += '</div>';
                                });

                                // Markup einfügen
                                entriesDiv.innerHTML = html;
                            }

                        }, this[key]);

                    }, r.entries);

                }
                else if(display_mode == 'mobile') {

                    // FahrerInnen
                    Object.keys(r.entries).forEach(function(key, index) {
                        var employess_id = key;

                        // Einträge
                        var entries = this[key];
                        var html = '';

                        var entriesDiv = document.querySelectorAll(".tablecontainer tr[data-employee-id='"+employess_id+"'] > td > .entries")[0];
                        if(typeof entriesDiv === 'object') {

                            // Markup der Einträge erstellen
                            entries.forEach(function(entry, i){

                                html += '<div data-id="'+entry.id+'" class="dienstplan-entry uk-light" style="background-color:#'+entry.route_color+';">';
                                html += '    <span class="title">'+entry.route_name+'</span>';
                                if(typeof entry.note !== 'undefined' && entry.note.length > 0) {
                                    html += '    '+entry.note;
                                }
                                html += '</div>';
                            });
                        }

                        // Markup einfügen
                        entriesDiv.innerHTML = html;

                    }, r.entries);

                }

                // Klick-Handler
                var entries = document.querySelectorAll(".tablecontainer .dienstplan-entry");
                entries.forEach(function(entry, i){
                    entry.addEventListener('click', function(event){

                        var entry = event.target.closest('.dienstplan-entry');
                        var id = parseInt( entry.getAttribute('data-id') );

                        if(display_mode == 'desktop') {
                            Dienstplan.editEntry(id);
                        }
                        else if(display_mode == 'mobile') {

                            // Daten zum Eintrag holen
                            Webapp.xhrRequest(
                                Webapp.getUrl('dienstplan-get-entrydata'),
                                'POST',
                                getFormData({ id: id }),
                                function(){},
                                function(){},
                                function(r){

                                    var inputId = document.querySelectorAll("#modal-entry-view input[name=id]")[0];
                                    inputId.value = id;

                                    var header = document.querySelectorAll("#modal-entry-view h2.uk-modal-title")[0];
                                    header.textContent = r.entry.route_name;
                                    header.style.color = '#'+r.entry.route_color;

                                    var note = document.querySelectorAll("#modal-entry-view p.note")[0];
                                    note.textContent = r.entry.note;

                                    var header_locations = document.querySelectorAll("#modal-entry-view .header-locations")[0];
                                    var table = document.querySelectorAll("#modal-entry-view table.locations tbody")[0];
                                    var locHtml = '';
                                    if(r.entry.locations.length > 0) {
                                        for(var i=0;i<r.entry.locations.length;i++) {
                                            locHtml += '<tr><td class="uk-table-expand name">'+r.entry.locations[i].name+'</td><td class="uk-table-shrink uk-text-right parktime">'+r.entry.locations[i].parktime+'</td></tr>';
                                        }
                                    }
                                    table.innerHTML = locHtml;
                                    if(locHtml == '') {
                                        header_locations.style.display = 'none';
                                    }
                                    else {
                                        header_locations.style.display = '';
                                    }

                                    // keine Verwaltungsberechtigung > alle Buttons ausblenden
                                    var actions = document.querySelectorAll("#modal-entry-view p.actions")[0];
                                    if(r.edit_perm == false) {
                                        actions.style.display = 'none';
                                    }
                                    else {
                                        actions.style.display = '';

                                        // nach oben schieben
                                        var btnMoveUp = document.querySelectorAll("#modal-entry-view .actions button.move-up")[0];
                                        var entryBefore = entry.previousElementSibling;
                                        if(entryBefore === null) {
                                            btnMoveUp.style.display = 'none';
                                        }
                                        else {
                                            btnMoveUp.style.display = '';
                                        }

                                        // nach unten schieben
                                        var btnMoveDown = document.querySelectorAll("#modal-entry-view .actions button.move-down")[0];
                                        var entryNext = entry.nextElementSibling;
                                        if(entryNext === null) {
                                            btnMoveDown.style.display = 'none';
                                        }
                                        else {
                                            btnMoveDown.style.display = '';
                                        }
                                    }

                                    // Modal anzeigen
                                    UIkit.modal(Dienstplan.modalView).show();
                                }
                            );
                        }
                    });
                });

            }
        );

        // in einer Minute prüfen ob sich etwas geändert hat
        clearTimeout(Dienstplan.timerUpdate);
        Dienstplan.timerUpdate = setTimeout(Dienstplan.checkUpdate, 30000);
    },

    checkUpdate: function() {

        clearTimeout(Dienstplan.timerUpdate);

        // Parameter
        var parameter = {};
        if(display_mode == 'desktop') {
            parameter = {
                roster_id: document.getElementById("input-roster").value,
                week: document.getElementById("input-week").value
            };
        }
        else if(display_mode == 'mobile') {
            parameter = {
                roster_id: document.getElementById("input-roster").value,
                day: document.getElementById("input-day").value
            };
        }

        // Daten laden
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-check-datachange'),
            'POST',
            getFormData(parameter),
            function(){},
            function(){},
            function(r){

                // ist gibt zwischenzeitliche Änderung
                if(r.lastChange > Dienstplan.timeLastLoading) {
                    Dienstplan.loadEntries();
                }

                else {
                    Dienstplan.timeLastLoading = r.lastChange;

                    // wieder in 30 Sek. prüfen
                    Dienstplan.timerUpdate = setTimeout(Dienstplan.checkUpdate, 30000);
                }
            }
        );
    },

    editEntry: function(id) {

        // ID übernehmen
        var inputId = Dienstplan.modalEdit.querySelectorAll('input[name=id]')[0];
        inputId.value = id;

        // Daten laden
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-get-entrydata'),
            'POST',
            getFormData({ id: id }),
            function(){},
            function(){},
            function(r){

                var inputRoute = Dienstplan.modalEdit.querySelectorAll('select[name=route_id]')[0];
                var inputNote = Dienstplan.modalEdit.querySelectorAll('input[name=note]')[0];

                // Werte setzen
                inputRoute.value = r.entry.route_id;
                inputNote.value = r.entry.note;

                // Modal anzeigen
                UIkit.modal(Dienstplan.modalEdit).show();
            }
        );
    },

    editNote: function(id) {

        // ID übernehmen
        var inputId = Dienstplan.modalNote.querySelectorAll('input[name=id]')[0];
        inputId.value = id;

        // Daten laden
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-get-entrydata'),
            'POST',
            getFormData({ id: id }),
            function(){},
            function(){},
            function(r){

                // Notiz einfügen
                var inputNote = Dienstplan.modalNote.querySelectorAll('input[name=note]')[0];
                inputNote.value = r.entry.note;

                // Modal anzeigen
                UIkit.modal(Dienstplan.modalNote).show();
            }
        );
    },

    movedEntry: function(event) {

        // Daten zusammenstellen
        var id = parseInt( event.detail[1].getAttribute('data-id') );
        var target_employee_id = parseInt( event.target.closest('tr').getAttribute('data-employee-id') );
        var target_weekday = parseInt( event.target.closest('td').getAttribute('data-weekday') );
        var before_id = 0;
        var eleBefore = event.detail[1].previousElementSibling;
        if(eleBefore) {
            before_id = eleBefore.getAttribute('data-id');
        }

        // Senden
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-move-entry'),
            'POST',
            getFormData({
                id: id,
                to_employee_id: target_employee_id,
                to_weekday: target_weekday,
                before_id: before_id
            }),
            function(){},
            function(){},
            function(r){}
        );
    },

    deleteAllEntries: function() {

        // Parameter
        var roster_id = document.getElementById("input-roster").value;
        var week = document.getElementById("input-week").value;
        var parameter = { roster_id: roster_id, week: week };

        // Löschung
        Webapp.xhrRequest(Webapp.getUrl('dienstplan-deleteall-entries'), 'POST', getFormData(parameter), function(){}, function(){}, function(data){

            var questionHeader = "Einträge löschen:";
            var questionText = "Möchten Sie wirklich alle Wocheneinträge löschen?";

            Webapp.modalDeletion(questionHeader, questionText).then(function() {
                parameter.confirmed = 1;
                Webapp.xhrRequest(Webapp.getUrl('dienstplan-deleteall-entries'), 'POST', getFormData(parameter), function(){}, function(){}, function(data){

                    Dienstplan.loadEntries();
                    Webapp.notification("Einträge wurden gelöscht!", 'success');
                });

            }, function(){});
        });
    },

    insertDefaultentries: function() {

        // Parameter
        var roster_id = document.getElementById("input-roster").value;
        var week = document.getElementById("input-week").value;

        // Einträge abrufen
        Webapp.xhrRequest(
            Webapp.getUrl('dienstplan-insert-defaultentries'),
            'POST',
            getFormData({ roster_id: roster_id, week: week }),
            function(){},
            function(){},
            function(r){
                Dienstplan.loadEntries();
                Webapp.notification('Standardeinträge eingefügt!', 'success');
            }
        );
    }
}

// Dienstplan
if(document.querySelectorAll('body.dienstplan').length === 1) {

    // Modul
    window.addEventListener('load', Dienstplan.init);
}

// Modul: Standardwoche
var Standardwoche = {

    modalAdd: null,
    modalEdit: null,

    init: function() {

        // Elemente
        Standardwoche.modalAdd = document.getElementById("modal-entry-add");
        Standardwoche.modalEdit = document.getElementById("modal-entry-edit");

        // Wechsel von Dienstplan
        var selectRoster = document.getElementById("input-roster");
        if(typeof selectRoster === 'object') {
            selectRoster.addEventListener('change', function(event){
                Webapp.goto('standardwoche', '', { roster_id: selectRoster.value });
            });
        }

        // Klick auf Eintrag hinzufügen
        var btns = document.querySelectorAll('.tablecontainer button.add');
        for (var i=0; i < btns.length; i++) {
            btns[i].addEventListener('click', function(event){

                // Inputs
                var inputEmployee   = Standardwoche.modalAdd.querySelectorAll('input[name=employee_id]')[0];
                var inputWeekday    = Standardwoche.modalAdd.querySelectorAll('input[name=weekday]')[0];
                var inputNote       = Standardwoche.modalAdd.querySelectorAll('input[name=note]')[0];

                // Angaben vorbelegen
                var tr = event.target.closest('tr');
                inputEmployee.value = parseInt(tr.getAttribute('data-employee-id'));
                var td = event.target.closest('td');
                inputWeekday.value = parseInt(td.getAttribute('data-weekday'));
                inputNote.value = '';

                // Modal anzeigen
                UIkit.modal(Standardwoche.modalAdd).show();
            });
        }

        // Form zum Hinzufügen senden
        Webapp.formSubmit(Webapp.getUrl('standardwoche-add-submit'), 'form-add', 'Eintrag hinzugefügt!', function(response){
            Standardwoche.loadEntries();
        });

        // Form bei Bearbeitung senden
        Webapp.formSubmit(Webapp.getUrl('standardwoche-edit-submit'), 'form-edit', 'Eintrag gespeichert!', function(response){
            Standardwoche.loadEntries();
        });

        // Eintrag löschen
        var btnDelete = document.getElementById("btn-entry-delete");
        if(typeof btnDelete === 'object') {
            btnDelete.addEventListener('click', function(event){
                var id = document.querySelectorAll('#modal-entry-edit input[name=id]')[0].value;
                Webapp.deletionDialog(
                    Webapp.getUrl('standardwoche-delete'),
                    { id: id },
                    function(){
                        var e = document.querySelectorAll('.tablecontainer .entries > .dienstplan-entry[data-id="'+id+'"]')[0];
                        e.parentNode.removeChild(e);
                        UIkit.modal(Standardwoche.modalEdit).hide();
                    }
                );
            });
        }

        // Einträge verschieben
        var sortableContainer = document.querySelectorAll('.tablecontainer .entries');
        for (var i=0; i < sortableContainer.length; i++) {

            UIkit.sortable(sortableContainer[i], { group: 'rosterentries' });

            UIkit.util.on(sortableContainer[i], 'moved', function (event) {
                Standardwoche.movedEntry(event);
            });
            UIkit.util.on(sortableContainer[i], 'added', function (event) {
                Standardwoche.movedEntry(event);
            });
        }

        // Einträge laden
        Standardwoche.loadEntries();
    },

    loadEntries: function() {

        // Parameter
        var roster_id = document.getElementById("input-roster").value;

        // Einträge abrufen
        Webapp.xhrRequest(
            Webapp.getUrl('standardwoche-load-entries'),
            'POST',
            getFormData({ roster_id: roster_id }),
            function(){},
            function(){},
            function(r){

                // Einträge aufräumen
                var olds = document.querySelectorAll(".tablecontainer .entries");
                for(var n=0;n<olds.length;++n) {
                    olds[n].innerHTML = '';
                }

                // Wochentage
                Object.keys(r.entries).forEach(function(key, index) {
                    var weekday = key;

                    // FahrerInnen
                    Object.keys(this[key]).forEach(function(key, index) {
                        var employess_id = key;

                        // Einträge
                        var entries = this[key];
                        var html = '';

                        var entriesDiv = document.querySelectorAll(".tablecontainer tr[data-employee-id='"+employess_id+"'] > td[data-weekday='"+weekday+"'] > .entries")[0];
                        if(entriesDiv !== undefined) {

                            // Markup der Einträge erstellen
                            entries.forEach(function(entry, i){

                                html += '<div data-id="'+entry.id+'" class="dienstplan-entry uk-light" style="background-color:#'+entry.route_color+';">';
                                html += '    <span class="title">'+entry.route_name+'</span>';
                                if(typeof entry.iteration !== 'undefined' && entry.iteration == 'evenweek') {
                                    html += '    <i>gerade Wochen</i><br>';
                                }
                                if(typeof entry.iteration !== 'undefined' && entry.iteration == 'oddweek') {
                                    html += '    <i>ungerade Wochen</i><br>';
                                }
                                if(typeof entry.note !== 'undefined' && entry.note.length > 0) {
                                    html += '    '+entry.note;
                                }
                                html += '</div>';
                            });

                            // Markup einfügen
                            entriesDiv.innerHTML = html;
                        }

                    }, this[key]);

                }, r.entries);

                // Klick-Handler
                var entries = document.querySelectorAll(".tablecontainer .dienstplan-entry");
                entries.forEach(function(entry, i){
                    entry.addEventListener('click', function(event){

                        var entry = event.target.closest('.dienstplan-entry');
                        var id = parseInt( entry.getAttribute('data-id') );

                        Standardwoche.editEntry(id);
                    });
                });

            }
        );
    },

    editEntry: function(id) {

        // ID übernehmen
        var inputId = Standardwoche.modalEdit.querySelectorAll('input[name=id]')[0];
        inputId.value = id;

        // Daten laden
        Webapp.xhrRequest(
            Webapp.getUrl('standardwoche-get-entrydata'),
            'POST',
            getFormData({ id: id }),
            function(){},
            function(){},
            function(r){

                var inputRoute = Standardwoche.modalEdit.querySelectorAll('select[name=route_id]')[0];
                var inputIterations = Standardwoche.modalEdit.querySelectorAll('input[name=iteration]');
                var inputNote = Standardwoche.modalEdit.querySelectorAll('input[name=note]')[0];

                // Werte setzen
                inputRoute.value = r.entry.route_id;
                for(var n=0;n<inputIterations.length;n++) {
                    var e = inputIterations[n];
                    e.checked = r.entry.iteration==e.value?true:false;
                }
                inputNote.value = r.entry.note;

                // Modal anzeigen
                UIkit.modal(Standardwoche.modalEdit).show();
            }
        );
    },

    movedEntry: function(event) {

        // Daten zusammenstellen
        var id = parseInt( event.detail[1].getAttribute('data-id') );
        var target_employee_id = parseInt( event.target.closest('tr').getAttribute('data-employee-id') );
        var target_weekday = parseInt( event.target.closest('td').getAttribute('data-weekday') );
        var before_id = 0;
        var eleBefore = event.detail[1].previousElementSibling;
        if(eleBefore) {
            before_id = eleBefore.getAttribute('data-id');
        }

        // Senden
        Webapp.xhrRequest(
            Webapp.getUrl('standardwoche-move-entry'),
            'POST',
            getFormData({
                id: id,
                to_employee_id: target_employee_id,
                to_weekday: target_weekday,
                before_id: before_id
            }),
            function(){},
            function(){},
            function(r){}
        );
    }
}

// Standardwoche
if(document.querySelectorAll('body.standardwoche').length === 1) {

    // Modul
    window.addEventListener('load', Standardwoche.init);
}


